import { render, staticRenderFns } from "./GameBagComponent.vue?vue&type=template&id=698649de&"
import script from "./GameBagComponent.vue?vue&type=script&lang=ts&"
export * from "./GameBagComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GameBagComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports